import React from 'react';
import PropTypes from 'prop-types';

const Stars = ({ reviewStars, reviewCount, reviewCountClassName = '' }) => {
  const populateStars = (reviewStars) => {
    const starsInt = reviewStars ? parseFloat((reviewStars)).toFixed(1) : 0;
    let stars = [];

    if (starsInt === 0) {
      return stars;
    }

    const halfStar = starsInt - parseInt(starsInt);

    for (let i = 1; i <= starsInt; i++) {
      stars.push('icon-full-star');
    }

    if (starsInt % 1 !== 0) {
      if((0.25 < halfStar) && (0.75 > halfStar)){
        stars.push('icon-half-star');
      } else if (0.25 > halfStar) {
        stars.push('icon-empty-star');
      } else {
        stars.push('icon-full-star');
      }
    }

    const emptyStars = 5 - starsInt;

    for (let j = 1; j <= emptyStars; j++) {
      stars.push('icon-empty-star');
    }

    return stars;
  };

  if (reviewStars && reviewCount) {
    return (
      <div className="stars-wrapper">
        { populateStars(reviewStars).map((star, i ) =>
          <span key={`stars-${i}`} className={`ico ico-md ${star}`} />)
        }
        <span className={reviewCountClassName} style={{ marginLeft: '8px' }}>{ reviewCount }</span>
      </div>
    );
  }

  return null;
};

export default Stars;
